module.exports = __webpack_public_path__ + "static/media/siddharth-palamaner-trip-05.ef4f3107.png";